import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import { FaCheckCircle, FaWhatsapp } from "react-icons/fa";

const ThankYouPopup = ({
  open,
  onClose,
  number = "9000000000",
  trackingId = "",
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          &times;
        </IconButton>
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <FaCheckCircle color="green" size={40} />
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6" align="center" gutterBottom>
          Thank you for submitting the form!
        </Typography>
        <Typography align="center">
          Our team will contact you on your this WhatsApp number soon.
        </Typography>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <FaWhatsapp color="green" size={30} style={{ marginRight: 6 }} />{" "}
          <spna style={{ fontSize: 24, fontWeight: 600 }}>{number}</spna>
        </div>
        <Typography align="center">
          Tracking ID:{" "}
          <span
            style={{
              border: "1px solid black",
              padding: 6,
              fontSize: 16,
              background: "#efecec",
            }}
          >
            {trackingId}
          </span>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ThankYouPopup;
